import React from 'react';
import ReactDOM from 'react-dom/client';
import "animate.css/animate.min.css";
import { BrowserRouter } from "react-router-dom";
import './fonts/argithea/Argithea.ttf';
import './fonts/centurygothic/CenturyGothic.ttf';
//import './fonts/centurygothic/CenturyGothicBold.ttf';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App /> 
    </BrowserRouter>
  </React.StrictMode>
);
